export default "__VITE_ASSET__BYzWnAhA__"